<template>
  <div
    class="modal fade"
    id="searchBank"
    tabindex="-1"
    role="dialog"
    aria-labelledby="searchBank"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">{{$t("bank.account.popup.bank_search")}}</h3>
        </div>
        <div class="modal-body">
          <div class="fieldset-cus">
            <form class="form-horizontal">
              <div class="form-group mb-0 overflow-auto">
                <label class="col-sm-4 control-label float-left mt-2">{{$t("bank.account.popup.search_bank_name")}}</label>
                <div class="col-sm-8 float-left">
                  <div class="input-group">
                    <input type="text" class="form-control input-bank" v-model="bankName">
                    <div class="input-group-btn">
                      <button class="btn btn-success btn-bank" @click.prevent="searchBankFromPopup(true)">{{$t("btn.search")}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <table class="table table-striped table-bordered text-center table-hover table-responsive table-bank">
            <thead>
              <tr>
                <th class="text-center text-bank">{{$t("bank.account.popup.bank_code")}}</th>
                <th class="text-center text-bank">{{$t("bank.account.popup.bank_name")}}</th>
                <th class="text-center text-bank">{{$t("bank.account.popup.selection")}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in listBank" :key="item.key">
                <td class="align-middle text-bank">{{item.bankCode}}</td>
                <td class="align-middle text-bank">{{item.bankName}}</td>
                <td style="width: 20%">
                  <button class="btn btn-info btn-bank" @click="selectBank(item.bankCode, item.bankName)">
                    {{$t("bank.account.popup.selection")}}
                  </button>
                </td>
              </tr>
              <tr>
                <td colspan="3" v-if="model.infoMessage != null" class="nodata message-bank">
                  {{$t(model.infoMessage)}}
                </td>
              </tr>
            </tbody>
          </table>
          <div align="center">
            <Pagination
              :total-pages="totalPage"
              :total="totalItems"
              :per-page="offset"
              :current-page="currentPage"
              @pagechanged="onPageChange"
              @pageJump="onPageJump"
              :previousText="$t('navigation.bt.previous')"
              :nextText="$t('navigation.bt.next')"
              :firstText="$t('navigation.bt.first')"
              :lastText="$t('navigation.bt.last')"
            ></Pagination>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary btn-bank" @click="hideWithConfirm()">{{$t("btn.close_windown")}}</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import ServiceUtils from "@/common/utils/ServiceUtils.js";
import Pagination from "@/components/base/Pagination.vue";
import $ from "jquery";

export default {
    name: "SearchBank",
    components: {Pagination},
    data() {
        return {
            SERVICE_NAME: "bankAccount",
            model: {},
            listBank: [],
            bankName: null,
            totalPage: 0,
            totalItems: 0,
            offset: 0,
            currentPage: 1,
        }
    },
    mounted() {
        this.onOpenSearchBankEvent();
        this.onCloseConfirmModal();
    },
    methods: {
        setPaginationInfo(pageNumber, offset, totalItems, totalPage, listItem) {
            this.currentPage = pageNumber;
            this.offset = offset;
            this.totalItems = totalItems;
            this.totalPage = totalItems === 0 ? 1 : totalPage;
            this.listBank = listItem;
        },
        onOpenSearchBankEvent() {
          ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_SEARCH_BANK, (params) => {
                $('#searchBank').modal({backdrop: 'static', keyboard: false});
                return this.show(params);
            });
        },
        onCloseConfirmModal() {
          ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_MODAL_CONFIRM + this.IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_BANK, () => {
                this.hide();
            });
        },
        show(params) {
            $("#searchBank").modal("show");
            this.model = params;
            this.setPaginationInfo(1, this.model.pagingInfo.offset, this.model.pagingInfo.total,
                this.model.pagingInfo.totalPage, this.model.listBank);
        },
        onPageChange(page) {
            this.currentPage = page;
            this.searchBankFromPopup(false);
        },
        onPageJump(page, previous, next, maxVisibleButtons) {
            this.currentPage = this.ServiceUtils.getCurrentPageOnPageJump(page, previous, next, maxVisibleButtons);
            this.searchBankFromPopup(false);
        },
        searchBankFromPopup(isBtnSearch) {
            if (this.bankName) this.bankName = this.bankName.trim()
            let bankName = this.bankName;
            let bankNameFullSize = null;
            let bankNameHalfSize = null;
            if (bankName) {
                if (isBtnSearch) this.currentPage = 1;
                bankNameFullSize = ServiceUtils.convertHalfToFull(bankName);
                bankNameHalfSize = ServiceUtils.convertFullwidthToHalfwidthReturn(bankName);
                if (bankNameFullSize == null || typeof bankNameFullSize == "undefined") {
                    bankNameFullSize = "";
                }
                if (bankNameHalfSize == null || typeof bankNameHalfSize == "undefined") {
                    bankNameHalfSize = "";
                }
                if (bankName == null || typeof bankName == "undefined") {
                    bankName = "";
                }

                bankName = encodeURIComponent(encodeURIComponent(bankName));
                bankNameFullSize = encodeURIComponent(encodeURIComponent(bankNameFullSize));
                bankNameHalfSize = encodeURIComponent(encodeURIComponent(bankNameHalfSize));
            }
            const params = "index=" + this.currentPage +
                "&bankName=" + (bankName ? bankName : "") +
                "&bankNameFullSize=" + (bankNameFullSize ? bankNameFullSize : "") +
                "&bankNameHalfSize=" + (bankNameHalfSize ? bankNameHalfSize : "");

            this.$service.getService(this.SERVICE_NAME).searchBankPopup(params).then((response) => {
                this.model = response;
                this.setPaginationInfo(this.currentPage, this.model.pagingInfo.offset, this.model.pagingInfo.total,
                    this.model.pagingInfo.totalPage, this.model.listBank);
            });
        },
        selectBank: function (bankCode, bankName) {
            const bankInfo = {
                bankCode: bankCode,
                bankName: bankName,
            };
            this.$modal.afterSelectBank(bankInfo);
            this.hide();
        },
        hide() {
            this.bankCode = null;
            this.bankName = null;
            $("#searchBank").modal("hide");
        },
        hideWithConfirm() {
            const params = {messageText: this.$t("MSG_FCM_007")};
            this.$modal.modalConfirm(params, this.IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_BANK);
        }
    }
}
</script>

<style scoped>
  .table-responsive {
    display: inline-table;
  }
  .modal-dialog {
    max-width: 600px;
  }
</style>
